module.exports = __webpack_public_path__ + "static/img/智能报账1.4537765c.png";